module.exports = __webpack_public_path__ + "img/p_20.9982991c.png";